<div class="percentage">
  <p>0</p>
  <p>20%</p>
  <p class="additional">40%</p>
  <p>60%</p>
  <p class="additional">80%</p>
  <p>100%</p>
</div>
